import { render, staticRenderFns } from "./MarketModal.vue?vue&type=template&id=2df5f5f9&scoped=true&"
import script from "./MarketModal.vue?vue&type=script&lang=js&"
export * from "./MarketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5f5f9",
  null
  
)

export default component.exports